import { BaseSendMessageModel } from "./MessageModel";

export interface Tender {
	Id: number;
	BusinessCategory: string;
	BusinessCategoryId: number;
	Description: string;
	Link: string;
	DateAdvertisedUtc: string;
	DateClosingUtc: string;
	DateCreatedUtc: string;
	Expired: boolean;
	CreatedByUserId: string;
	Province: string;
	ProvinceId: string;
	DateOfBriefing: string | null;
	TenderDocumentId: any | null;
	TenderTypeId: TenderTypeEnum | null;
	TenderType: string;
	TenderIssuer: string;
	TenderNumber: string;
	PlaceOfService: string | null;
	SpecialConditions: string | null;
	ContactPerson: string | null;
	ContactEmail: string | null;
	ContactNumber: string | null;
}


export class CreateTenderModel extends BaseSendMessageModel {
	businessCategoryId: number;
	description: string;
	link: string;
	dateAdvertised: Date;
	dateClosing: Date | null;
	dateOfBriefing: Date | null;
	provinceId: string;
	tenderDocumentId: any | null = null;
	tenderTypeId: TenderTypeEnum | null = null;
	tenderType: string;
	tenderIssuer: string;
	tenderNumber: string;
	placeOfService: string | null;
	specialConditions: string | null;
	contactPerson: string | null;
	contactEmail: string | null;
	contactNumber: string | null;
}

export class EditTenderModel extends CreateTenderModel {
	id: number;
	constructor(item?: Tender) {
		super();
		this.id = item && item.Id;
		this.businessCategoryId = item && item.BusinessCategoryId;
		this.description = item && item.Description;
		this.link = item && item.Link;
		this.dateAdvertised = parseDate(item.DateAdvertisedUtc);
		this.dateClosing = parseDate(item.DateClosingUtc);
		this.dateOfBriefing = (item.DateOfBriefing) ? parseDate(item.DateOfBriefing) : null;
		this.provinceId = item && item.ProvinceId;
		this.tenderDocumentId = (item.TenderDocumentId !== null) ? item.TenderDocumentId : null;
		this.tenderTypeId = (item.TenderTypeId !== null) ? item.TenderTypeId : null;
		this.tenderIssuer = (item && item.TenderIssuer !== null) ? item.TenderIssuer : null;
		this.tenderNumber = (item && item.TenderNumber !== null) ? item.TenderNumber : null;
		this.placeOfService = (item && item.PlaceOfService !== null) ? item.PlaceOfService : null;
		this.specialConditions = (item && item.SpecialConditions !== null) ? item.SpecialConditions : null;
		this.contactPerson = (item && item.ContactPerson !== null) ? item.ContactPerson : null;
		this.contactEmail = (item && item.ContactEmail !== null) ? item.ContactEmail : null;
		this.contactNumber = (item && item.ContactNumber !== null) ? item.ContactNumber : null;
	}
}

export const parseDate = (input: string) => {
	let dateParts = input.substring(0, 10).split("-");
	let dateLocal = new Date(Date.UTC(parseInt(dateParts[0]), parseInt(dateParts[1])-1, parseInt(dateParts[2]), 12));
	let timeOffset = dateLocal.getTimezoneOffset();
	let dateLocalWithOffset = new Date(dateLocal.getTime() + timeOffset*60000);
	return dateLocalWithOffset;
  };

export enum TenderTypeEnum {
	RFP = 1,
	RFQ = 2,
	RFI = 3
  }


// WEBPACK FOOTER //
// ./src/app/models/inModels/Tender.ts